import React from 'react';
import {useRef} from 'react';

import {motion} from 'framer-motion';
import {useInView} from 'framer-motion';

export const VideoSection3: React.FC<React.PropsWithChildren<unknown>> = () => {
  const ref = useRef(null);
  // const isInView = useInView(ref, {once: true, amount: 0.3});

  return (
    <section ref={ref} className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Two-column layout with video and content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left side - Video */}
          <motion.div
            className="relative"
            // initial={{opacity: 0, x: -50}}
            // animate={isInView ? {opacity: 1, x: 0} : {}}
            // transition={{duration: 0.8, delay: 0.3}}
          >
            <div className="relative rounded-2xl overflow-hidden shadow-lg">
              <video
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-80 object-cover"
              >
                <source src="/images/stryd5/exploded.mp4" type="video/mp4" />
              </video>

              {/* Text overlays positioned on the video */}
              {/* <motion.div
                className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm rounded-lg px-3 py-2"
                initial={{opacity: 0, scale: 0.8}}
                animate={isInView ? {opacity: 1, scale: 1} : {}}
                transition={{duration: 0.6, delay: 0.8}}
              >
                <div className="text-sm font-semibold text-gray-800">
                  Precision Sensors
                </div>
                <div className="text-xs text-gray-600">Advanced technology</div>
              </motion.div>

              <motion.div
                className="absolute top-4 right-4 bg-blue-600 text-white rounded-lg px-3 py-2"
                initial={{opacity: 0, scale: 0.8}}
                animate={isInView ? {opacity: 1, scale: 1} : {}}
                transition={{duration: 0.6, delay: 1.0}}
              >
                <div className="text-sm font-semibold">H2 Chip</div>
                <div className="text-xs opacity-90">Processing power</div>
              </motion.div>

              <motion.div
                className="absolute bottom-4 left-4 bg-white/90 backdrop-blur-sm rounded-lg px-3 py-2"
                initial={{opacity: 0, scale: 0.8}}
                animate={isInView ? {opacity: 1, scale: 1} : {}}
                transition={{duration: 0.6, delay: 1.2}}
              >
                <div className="text-sm font-semibold text-gray-800">
                  Refined Algorithms
                </div>
                <div className="text-xs text-gray-600">
                  2x faster processing
                </div>
              </motion.div>

              <motion.div
                className="absolute bottom-4 right-4 bg-green-600 text-white rounded-lg px-3 py-2"
                initial={{opacity: 0, scale: 0.8}}
                animate={isInView ? {opacity: 1, scale: 1} : {}}
                transition={{duration: 0.6, delay: 1.4}}
              >
                <div className="text-sm font-semibold">40% Faster</div>
                <div className="text-xs opacity-90">Response time</div>
              </motion.div> */}
            </div>
          </motion.div>

          {/* Right side - Content */}
          <motion.div
          // initial={{opacity: 0, x: 50}}
          // animate={isInView ? {opacity: 1, x: 0} : {}}
          // transition={{duration: 0.8, delay: 0.5}}
          >
            <h2 className="text-4xl md:text-5xl font-light text-black mb-6 leading-tight">
              Engineering your running
              <br />
              excellence
            </h2>

            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              From the advanced sensors that capture your every step to the
              refined algorithms that process data in real-time, every detail is
              optimized for performance.
            </p>

            <div className="space-y-4">
              <motion.div
                className="flex items-center gap-4"
                // initial={{opacity: 0, x: 20}}
                // animate={isInView ? {opacity: 1, x: 0} : {}}
                // transition={{duration: 0.6, delay: 0.8}}
              >
                <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                <span className="text-gray-700">
                  Enviromental port to capture the impact of wind, heat, and
                  humidity
                </span>
              </motion.div>

              <motion.div
                className="flex items-center gap-4"
                // initial={{opacity: 0, x: 20}}
                // animate={isInView ? {opacity: 1, x: 0} : {}}
                // transition={{duration: 0.6, delay: 1.0}}
              >
                <div className="w-2 h-2 bg-green-600 rounded-full"></div>
                <span className="text-gray-700">
                  Improved accuracy for pace, distance, and power
                </span>
              </motion.div>

              <motion.div
                className="flex items-center gap-4"
                // initial={{opacity: 0, x: 20}}
                // animate={isInView ? {opacity: 1, x: 0} : {}}
                // transition={{duration: 0.6, delay: 1.2}}
              >
                <div className="w-2 h-2 bg-purple-600 rounded-full"></div>
                <span className="text-gray-700">
                  Quicker response on climbs and descents
                </span>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
